import React from "react"
import { useStore } from "../../../stores/RootStoreContext"
import { ClientRequestList } from "../../client/request/ClientRequestList"
import { ManagerRequestList } from "../../manager/request/ManagerRequestList"

export const RequestList = () => {
  const { userStore } = useStore()

  if (userStore.isClient) {
    return <ClientRequestList />
  } else if (userStore.isManager || userStore.isAdmin) {
    return <ManagerRequestList />
  } else {
    return <></>
  }
}
